import React, { useState } from "react";
import Table from "../../../parts/table/Table";
import {
  LockClosedIcon,
  LockOpenIcon,
  DocumentTextIcon,
  PencilIcon,
  AnnotationIcon,
} from "@heroicons/react/outline";
import SMSwitch from "../../../elements/switch/SMSwitch";
import SMModal from "../../../elements/modals/SMModal";
import ChatBox from "../../../parts/chat-box/ChatBox";
import axiosAPI from "../../../utils/axios-api";
import { Link } from "react-router-dom";

const API = process.env.REACT_APP_API;
function PartisipasiTable(props) {
  const [modal, setmodal] = useState(false);
  const [id, setid] = useState(null);
  const columns = [
    {
      Header: "Waktu",
      id: "waktu",
      Cell: ({ row }) => {
        return (
          <div className="flex flex-col">
            <p className="text-sm text-blue-500">
              {row.original.tanggal_buka.replace(/-/g, "/")}
            </p>
            {/* <p>-</p> */}
            <p className="text-sm text-blue-500">
              {row.original.tanggal_tutup.replace(/-/g, "/")}
            </p>
          </div>
        );
      },
    },
    {
      Header: "Institusi",
      accessor: "nama_institusi",
    },
    {
      Header: "judul",
      accessor: "judul",
    },
    {
      Header: "Pemilik",
      accessor: "name",
    },
    {
      Header: "Sifat",
      id: "sifat",
      Cell: ({ row }) => {
        if (row.original.sifat === "terbuka") {
          return (
            <button onClick={() => console.log(row)}>
              <LockOpenIcon className="h-6 w-6 text-green-600" />
            </button>
          );
        } else {
          return (
            <button onClick={() => console.log(row)}>
              <LockClosedIcon className="h-6 w-6" />
            </button>
          );
        }
      },
    },
    {
      Header: "Bentuk",
      accessor: "tipe",
    },
    {
      Header: "Panduan",
      id: "panduan",
      Cell: ({ row }) => {
        return (
          <button>
            <DocumentTextIcon className="h-6 w-6" />
          </button>
        );
      },
    },
    {
      Header: "Scoin",
      accessor: "scoin",
    },
    {
      Header: "Poin",
      accessor: "poin",
    },
    {
      Header: "PU",
      id: "pu",
      Cell: ({ row }) => {
        const status = row.original.partisipasi_pu;
        if (status === "menunggu") {
          return (
            <div className="flex flex-col">
              <button
                onClick={() =>
                  kirimPersetujuan({ status: 1, id: row.original.id })
                }
                className="py-1 mb-1 px-4 rounded-full bg-blue-500 text-white dark:text-white text-sm"
              >
                Terima
              </button>
              <button
                onClick={() =>
                  kirimPersetujuan({ status: 0, id: row.original.id })
                }
                className="py-1 px-4 rounded-full bg-white dark:bg-gray-800 border border-blue-500 text-blue-600 dark:text-white text-sm"
              >
                Tolak
              </button>
            </div>
          );
        } else if (status === "diterima") {
          return (
            <button className="py-1 my-2 px-4 rounded-full bg-white dark:bg-gray-800 border border-green-500 text-green-600 dark:text-white text-sm">
              Diterima
            </button>
          );
        } else {
          return (
            <button className="py-1 my-2 px-4 rounded-full bg-white dark:bg-gray-800 border border-green-500 text-green-600 dark:text-white text-sm">
              -
            </button>
          );
        }
      },
    },
    {
      Header: "PD",
      id: "partisipasi_pd",
      Cell: ({ row }) => {
        if (row.original.partisipasi_pd === "diterima") {
          return (
            <span className="py-1 my-2 px-4 rounded-full bg-white dark:bg-gray-800 border border-blue-500 text-blue-600 dark:text-white text-sm">
              Diterima
            </span>
          );
        } else if (row.original.partisipasi_pd === "ditolak") {
          return (
            <span className="py-1 my-2 px-4 rounded-full bg-white dark:bg-gray-800 border border-red-500 text-red-600 dark:text-white text-sm">
              Ditolak
            </span>
          );
        } else {
          return (
            <span className="py-1 my-2 px-4 rounded-full bg-white dark:bg-gray-800 border border-blue-500 text-blue-600 dark:text-white text-sm">
              -
            </span>
          );
        }
      },
    },
    {
      Header: "SR",
      id: "sr",
      Cell: ({ row }) => {
        if (row.original.sr === 1) {
          return (
            <span className="py-1 my-2 px-4 rounded-full bg-white dark:bg-gray-800 border border-blue-500 text-blue-600 dark:text-white text-sm">
              OK
            </span>
          );
        } else {
          return (
            <span className="py-1 my-2 px-4 rounded-full bg-white dark:bg-gray-800 border border-blue-500 text-blue-600 dark:text-white text-sm">
              -
            </span>
          );
        }
      },
    },
    {
      Header: "Kerjakan",
      id: "edit",
      Cell: ({ row }) => {
        const partisipasi_pu = row.original.partisipasi_pu;
        const partisipasi_pd = row.original.partisipasi_pd;
        const status_jawaban = row.original.status_jawaban
        if (status_jawaban === 0 && partisipasi_pd !== "menunggu") {
          return (
            <Link className="flex" to={`/isi-kuesioner/${row.original.kuisioner_id}`}>
              <span className="flex rounded-full items-center justify-center p-2 bg-blue-200">
                <PencilIcon className="h-6 w-6" />
              </span>
            </Link>
          );
        } else if (partisipasi_pu === "--" && partisipasi_pd === "diterima") {
          return (
            <button className="flex rounded-full items-center justify-center p-2 bg-gray-200">
              <PencilIcon className="h-6 w-6" />
            </button>
          );
        } else if (status_jawaban === 1) {
          return (
            <button className="flex text-sm rounded-full items-center justify-center p-2 bg-gray-200">
              Sudah di isi
            </button>
          );
        }
      },
    },
    {
      Header: "Chat",
      id: "Chat",
      Cell: ({ row }) => {
        return (
          <button onClick={() => {
            setmodal(!modal)
            setid(row.original.id)
          }}>
            <AnnotationIcon className="h-6 w-6" />
          </button>
        );
      },
    },
  ];

  function kirimPersetujuan(params) {
    let body = { status: params.status };
    axiosAPI
      .post(API + "responden/" + params.id + "/persetujuan-undangan", body)
      .then((res) => {
        console.log(res.data.data);
        props.onRefresh();
      });
  }
  return (
    <>
      <SMModal
        show={modal}
        onClose={() => {
          setmodal(!modal)
          setid(null)
        }}
        title="Chat"
        disableOverlayClose={true}
      >
        <ChatBox id={id} />
      </SMModal>
      <Table columns={columns} data={props.data ?? []} />
    </>
  );
}

PartisipasiTable.propTypes = {};

export default PartisipasiTable;
